import script from "./report-graphs-subnav-controls.vue?vue&type=script&setup=true&lang=ts"
export * from "./report-graphs-subnav-controls.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__